import { Box } from "@mui/material";
import useColors from "../../../../api/hooks/useColors";
import LoadingIcon from "../../../../components/LoadingIcon";
import ScenariosSingleFlow from "./ScenariosSingleFlow";

const SingleScenariosPages = ({
  scenarioSet,
  pageScenarios,
  numberOfScenariosInPage,
  fetchedSteps,
  selectedAsset,
  height,
  scenarios,
}) => {
  const colors = useColors();

  const startIndex = pageScenarios * numberOfScenariosInPage;
  const endIndex =
    startIndex + numberOfScenariosInPage > scenarios?.length
      ? scenarios?.length
      : startIndex + numberOfScenariosInPage;

  return (
    <>
      {scenarioSet && fetchedSteps && selectedAsset && scenarios ? (
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            backgroundColor: colors.grey_2percent,
            border: "1px solid " + colors.grey_32percent,
            borderRadius: "8px",
            gap: "16px",
            padding: "16px",
          }}
        >
          {scenarios?.slice(startIndex, endIndex).map((scenario) => (
            <ScenariosSingleFlow
              key={scenario.scenario_id}
              scenario={scenario}
              scenarioSet={scenarioSet}
              fetchedSteps={fetchedSteps}
              selectedAsset={selectedAsset}
              height={height - 96}
              numberOfScenariosInPage={numberOfScenariosInPage}
            />
          ))}
        </Box>
      ) : (
        <LoadingIcon />
      )}
    </>
  );
};

export default SingleScenariosPages;
